import React from 'react';

interface Props {
	visible?: boolean;
}

const IconEye = ({ visible }: Props) => {
	return visible ? (
		<svg
			width="20"
			height="14"
			viewBox="0 0 20 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.3211 6.74688C19.2937 6.68516 18.632 5.21719 17.1609 3.74609C15.2008 1.78594 12.725 0.75 9.99999 0.75C7.27499 0.75 4.79921 1.78594 2.83905 3.74609C1.36796 5.21719 0.703118 6.6875 0.678899 6.74688C0.643362 6.82681 0.625 6.91331 0.625 7.00078C0.625 7.08826 0.643362 7.17476 0.678899 7.25469C0.706243 7.31641 1.36796 8.78359 2.83905 10.2547C4.79921 12.2141 7.27499 13.25 9.99999 13.25C12.725 13.25 15.2008 12.2141 17.1609 10.2547C18.632 8.78359 19.2937 7.31641 19.3211 7.25469C19.3566 7.17476 19.375 7.08826 19.375 7.00078C19.375 6.91331 19.3566 6.82681 19.3211 6.74688ZM9.99999 10.125C9.38193 10.125 8.77774 9.94172 8.26383 9.59834C7.74993 9.25496 7.34939 8.7669 7.11287 8.19589C6.87634 7.62487 6.81446 6.99653 6.93504 6.39034C7.05562 5.78415 7.35324 5.22733 7.79028 4.79029C8.22732 4.35325 8.78414 4.05562 9.39033 3.93505C9.99652 3.81447 10.6249 3.87635 11.1959 4.11288C11.7669 4.3494 12.255 4.74994 12.5983 5.26384C12.9417 5.77775 13.125 6.38193 13.125 7C13.125 7.8288 12.7958 8.62366 12.2097 9.20971C11.6236 9.79576 10.8288 10.125 9.99999 10.125Z"
				fill="#3C3C43"
				fillOpacity="0.6"
			/>
		</svg>
	) : (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.3249 10.2499C19.2582 10.3916 18.3666 12.3332 16.3832 13.9749L15.4833 13.0749L13.5666 11.1582C13.6832 10.7915 13.75 10.3999 13.75 9.99988C13.75 7.93321 12.0666 6.24988 9.99995 6.24988C9.59162 6.24988 9.19995 6.31654 8.84162 6.43321L6.69995 4.29154C7.66667 3.94982 8.75829 3.74988 9.99995 3.74988C16.5833 3.74988 19.2083 9.49988 19.325 9.74988C19.3916 9.90821 19.3916 10.0916 19.325 10.2499H19.3249Z"
				fill="#3C3C43"
				fillOpacity="0.6"
			/>
			<path
				d="M13.2917 15.7166C12.3333 16.0499 11.2333 16.2499 10 16.2499C3.41667 16.2499 0.791667 10.4999 0.675 10.2499C0.608333 10.0916 0.608333 9.9082 0.675 9.74987C0.741667 9.6082 1.63333 7.66654 3.61667 6.0332L4.50828 6.92487L6.43328 8.84987C6.30833 9.21654 6.24994 9.59987 6.24994 9.99987C6.24994 12.0666 7.93328 13.7499 9.99994 13.7499C10.3999 13.7499 10.7916 13.6833 11.1499 13.5665L12.2833 14.6999L13.2916 15.7165L13.2917 15.7166Z"
				fill="#3C3C43"
				fillOpacity="0.6"
			/>
			<path
				d="M16.8213 17.4467C16.6609 17.4467 16.5014 17.3856 16.3794 17.2636L2.73684 3.62017C2.49267 3.376 2.49267 2.9805 2.73684 2.73639C2.981 2.49228 3.3765 2.49222 3.62061 2.73639L17.2632 16.3798C17.5073 16.6239 17.5073 17.0194 17.2632 17.2636C17.1411 17.3856 16.9816 17.4467 16.8213 17.4467Z"
				fill="#3C3C43"
				fillOpacity="0.6"
			/>
		</svg>
	);
};

export default IconEye;
